import { useTheme } from '../context/ThemeContext';

/**
 * Subtle SP brand footer. Present on every authenticated page.
 *
 * Tiny navy/teal brand strip + mark + tagline + year — no more than one
 * line tall so it never competes with page content.
 */
export default function BrandFooter() {
  const { dark } = useTheme();
  return (
    <footer className="mt-16 border-t border-border/60 bg-background/60" data-testid="brand-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <img
              src="/brand/sp-logo.png"
              alt="SP Radiology Assistant"
              className="h-7 w-auto object-contain"
            />
            <span
              className="text-[10px] italic"
              style={{ color: 'var(--i3-teal)', fontFamily: "'Museo Slab','Zilla Slab','Outfit',sans-serif", fontWeight: 300 }}
            >
              Sanctuary Point · Ultrasound · Radiology
            </span>
          </div>
          <div className="flex items-center gap-3 text-[10px] text-muted-foreground uppercase tracking-[0.14em]">
            <span>Radiology Assistant</span>
            <span className="w-1 h-1 rounded-full bg-muted-foreground/40" />
            <span>© {new Date().getFullYear()} SP Radiology</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
